export interface ExpressionData {
  // Id is generated at runtime
  id?: string;
  expressionName: string;
  expressionPlaceholder?: string;
  expressionType: ExpressionTypes;
  expressionCategory?: string;
  expressionDimension?: { width: number; height: number };
}

export enum ExpressionTypes {
  FreeText = 1,
  Rectangle = 2,
  Circle = 3,
  TextExpression = 4,
  ImageExpression = 5,
  CheckboxExpression = 6,
}

export interface AnnotationDefaults {
  fontSize?: number;
  fontFamily?: string;
  fontColor?: string;
}
